import { ActionIcon, Box, Flex, Icon, TextInput } from '@tf/ui';
import { useState } from 'react';

import { useProfileExternalId, useUpdateProfileExternalId } from '@/core/api/alias';
import { useSelectedAccount } from '@/core/hooks';

export const AccountIdEditor = () => {
	const [isEditMode, setIsEditMode] = useState(false);
	const [text, setText] = useState('');
	const [error, setError] = useState('');

	const { profileId } = useSelectedAccount();
	const { data: externalId } = useProfileExternalId(profileId ?? '');
	const updateProfileExternalId = useUpdateProfileExternalId();

	const editExternalId = () => {
		setIsEditMode(true);
		if (!externalId) return;
		setText(externalId);
	};

	if (!profileId) {
		return <Box h="30px" />;
	}

	if (isEditMode) {
		return (
			<Flex align="flex-start">
				<TextInput
					error={error}
					onChange={(e) => {
						setText(e.target.value);
						setError('');
					}}
					size="xs"
					value={text}
				/>
				<ActionIcon
					size="xs"
					m="4px"
					variant="transparent"
					onClick={() => {
						if (!text) {
							setError('Account ID is required');
							return;
						}
						updateProfileExternalId.mutate(
							{ objectId: profileId, value: text.trim() },
							{
								onSuccess: () => {
									setIsEditMode(false);
								},
								onError: () => {
									setError('Error while updating account ID, try another one');
								},
							},
						);
					}}
				>
					<Icon.IconCheck />
				</ActionIcon>
			</Flex>
		);
	}

	return (
		<Flex h="30px" align="center">
			{externalId ? <Box>{`Account ID: ${externalId}`}</Box> : <Box>Account ID is not set</Box>}
			<ActionIcon size="xs" m="0 4px" variant="transparent" onClick={editExternalId}>
				<Icon.IconEdit />
			</ActionIcon>
		</Flex>
	);
};
